import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export interface Category {
  id: string;
  key: string;
  label: string;
  emoji: string;
  color: string;
  active: boolean;
  sort_order: number;
}

const FALLBACK_CATEGORIES: Category[] = [
  { id: '1', key: 'funny',        label: 'Funny',        emoji: '😄', color: 'amber',     active: true, sort_order: 1 },
  { id: '2', key: 'first',        label: 'First',        emoji: '⭐', color: 'yellow',    active: true, sort_order: 2 },
  { id: '3', key: 'milestone',    label: 'Milestone',    emoji: '🏆', color: 'green',     active: true, sort_order: 3 },
  { id: '4', key: 'conversation', label: 'Conversation', emoji: '💬', color: 'blue',      active: true, sort_order: 4 },
  { id: '5', key: 'drawing',      label: 'Drawing',      emoji: '🎨', color: 'purple',    active: true, sort_order: 5 },
  { id: '6', key: 'thankful',     label: 'Thankful',     emoji: '🙏', color: 'terracotta',active: true, sort_order: 6 },
  { id: '7', key: 'travel',       label: 'Travel',       emoji: '✈️', color: 'sky',       active: true, sort_order: 7 },
  { id: '8', key: 'achievement',  label: 'Achievement',  emoji: '🌟', color: 'teal',      active: true, sort_order: 8 },
  { id: '9', key: 'holiday',      label: 'Holiday',      emoji: '🎉', color: 'pink',      active: true, sort_order: 9 },
];

export function useCategories() {
  const query = useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('memory_categories')
        .select('id, key, label, emoji, color, active, sort_order')
        .order('sort_order');
      if (error) return FALLBACK_CATEGORIES;
      return (data as Category[] | null) ?? FALLBACK_CATEGORIES;
    },
  });

  const categories = query.data ?? FALLBACK_CATEGORIES;
  const activeCategories = categories.filter((c) => c.active);

  const getCategoryStyle = (label: string) => {
    const cat = categories.find(
      (c) => c.label.toLowerCase() === label.toLowerCase(),
    );
    return {
      emoji: cat?.emoji ?? '📝',
      color: cat?.color ?? 'gray',
    };
  };

  return {
    data: query.data,
    categories,
    activeCategories,
    getCategoryStyle,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
